import React from "react";

export default class BlockHowToGuidesDemolition extends React.Component  
{    
    render()
    {
        return (
            <div className="block how-to-guides demolition">
                <h2>How-To Guides</h2>
                <div className="provider-card card">    
                    <ul className="items-list">
                      <li key="htg-li-1" className="item">
                        <a href={'/blog/getting-started-with-demo'}>
                            <span className="icon-demolition">
                                <img src="/images/icons/demolition-started.png" alt="getting started" loading="lazy"/>
                            </span>
                            <div className="item-text">
                                <h5>GETTING STARTED</h5>
                                <h6>Demolition 101 begins</h6>
                            </div>
                        </a>
                      </li>
                      <li key="htg-li-2" className="item">
                        <a href={'/blog/how-much-does-demolition-cost-per-square-foot'}>
                            <span className="icon-demolition">
                                <img src="/images/icons/demolition-cost.png" alt="demolition cost" loading="lazy"/>
                            </span>
                            <div className="item-text">
                                <h5>Demolition Cost</h5>
                                <h6>Understanding quotes and prices</h6>
                            </div>
                        </a>
                      </li>
                      <li key="htg-li-3" className="item">
                        <a href={'/blog/barn-demolition-and-deconstruction-process'}>
                            <span className="icon-demolition">
                                <img src="/images/icons/demolition-barn.png" alt="barn removal" loading="lazy"/>
                            </span>
                            <div className="item-text">
                                <h5>Barn Removal</h5>
                                <h6>How it works and how much it costs</h6>
                            </div>
                        </a>
                      </li>
                      <li key="htg-li-4" className="item">
                        <a href={'/blog/concrete-demolition-removal-everything-homeowners-need-to-know'}>
                            <span className="icon-demolition">
                                <img src="/images/icons/demolition-concrete_removal.png" alt="concrete removal" loading="lazy"/>
                            </span>
                            <div className="item-text">
                                <h5>Concrete Removal</h5>
                                <h6>See removal processes and pricing</h6>
                            </div>
                        </a>
                      </li>
                      <li key="htg-li-5" className="item">
                        <a href={'/blog/the-homeowners-guide-to-demolishing-a-house'}>
                            <span className="icon-demolition">
                                <img src="/images/icons/demolition-house.png" alt="house demolition" loading="lazy"/>
                            </span>
                            <div className="item-text">
                                <h5>House Demolition</h5>
                                <h6>How it's done and how much it costs</h6>
                            </div>
                        </a>
                      </li>
                      <li key="htg-li-6" className="item">
                        <a href={'/blog/the-homeowners-guide-to-demolishing-a-house'}>
                            <span className="icon-demolition">
                                <img src="/images/icons/demolition-interior.png" alt="interior demolition" loading="lazy"/>
                            </span>
                            <div className="item-text">
                                <h5>Interior Demolition</h5>
                                <h6>Kitchens, bathrooms, basements, and more</h6>
                            </div>
                        </a>
                      </li>
                      <li key="htg-li-7" className="item">
                        <a href={'/blog/homeowners-guide-to-mobile-home-removal'}>
                            <span className="icon-demolition">
                                <img src="/images/icons/demolition-home_mobile.png" alt="mobile home removal" loading="lazy"/>
                            </span>
                            <div className="item-text">
                                <h5>Mobile Home Removal</h5>
                                <h6>Demolition, relocation, costs, etc.</h6>
                            </div>
                        </a>
                      </li>
                      <li key="htg-li-8" className="item">
                        <a href={'/blog/the-homeowners-guide-to-swimming-pool-demolition-and-removal'}>
                            <span className="icon-demolition">
                                <img src="/images/icons/demolition-pool_removal.png" alt="pool removal" loading="lazy"/>
                            </span>
                            <div className="item-text">
                                <h5>Pool Removal</h5>
                                <h6>Learn about removal methods and pricing</h6>
                            </div>
                        </a>
                      </li>
                      <li key="htg-li-9" className="item">
                        <a href={'/blog/homeowners-guide-to-underground-oil-tank-removal'}>
                            <span className="icon-demolition">
                                <img src="/images/icons/demolition-tank_removal.png" alt="tank removal" loading="lazy"/>
                            </span>
                            <div className="item-text">
                                <h5>Tank Removal</h5>
                                <h6>Under and aboveground tank removal</h6>
                            </div>
                        </a>
                      </li>
                      <li key="htg-li-10" className="item">
                        <a href={'/blog/an-introduction-to-chimney-removal'}>
                            <span className="icon-demolition">
                                <img src="/images/icons/demolition-chimney_removal.png" alt="chimney removal" loading="lazy"/>
                            </span>
                            <div className="item-text">
                                <h5>Chimney Removal</h5>
                                <h6>Discover removal processes and costs</h6>
                            </div>
                        </a>
                      </li>
                    </ul>                    
                </div>
            </div>
        )
    }
};